import type {ZodError} from 'zod';

export const processZodErrors = (
  zodError: ZodError,
): Record<string, string> => {
  const fieldErrors: Record<string, string> = {};

  zodError.issues.forEach((issue) => {
    const field: PropertyKey = issue.path[0];

    if (field) {
      fieldErrors[String(field)] = issue.message;
    }
  });

  return fieldErrors;
};
